import {
  TimeSheet,BudgetAll,Supply
} from "@/API/api";
import Qs from 'qs';
import {
  Message
} from "element-ui";
import {
  thousandSplit
} from '@/util/util.js'
export default {
  components: {
    // Toast,
  },
  data() {
    let validatorEstimatedRevenue = (rule, value, callback) => {
      console.log(value, Number(value) )
      if (!value&&value!=0) return callback(new Error('请输入预计收入'))
      if (!Number(value) && Number(value)!=0) return callback(new Error('预计收入为数字值'))
      let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/; //小数限制0-2位
      // let reg = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
      if (!reg.test(value)) return callback(new Error('预计收入小数限制为两位'));
      callback();
    }
    let validatorManHourInput= (rule, value, callback) => {
      console.log(!value,'!value',value,'value=====')
      if (!value && value != 0) return callback(new Error('请输入人工时投入'))
      if (!Number(value) && Number(value) != 0) return callback(new Error('人工时投入为数字值'))
      let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1})?$/; //小数限制1位
      // let reg = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
      if (!reg.test(value)) return callback(new Error('人工时投入小数限制为一位'));
      callback();
    }
    let validatorEstimatedOutgoingAmount= (rule, value, callback) => {
      console.log(!value,'!value',value,'value=====')
      // if (!value) return callback(new Error('请输入预计外发金额'))
      if (!Number(value)) return callback(new Error('预计外发预算为数字值'))
      let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/; //小数限制0-2位
      // let reg = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
      if (!reg.test(value)) return callback(new Error('预计外发预算小数限制为两位'));
      callback();
    }

    return {
      saveBtn:false,
      ruleForm: {
        projectId:Number(this.$route.query.pId),
        deliverablesTypeId: '', //交付物类型
        deliverablesName: '', //交付物名称
        deliverablesQuantity: '', //交付物数量
        estimatedRevenue: '', //预计收入
        outgoingUnitList: [
        //   {
        //   companyId: '',
        //   estimatedOutgoingAmount: '',
        // },
       ], //外发单位
        staffingList: [{
          humanEfficiencyCalculation: '', //人效计算
          manHourInput: '', //人工时投入
          rate: '', //rate
          userId: '',
          // peopleInvestment: '', //预计人力投资
        }, ], //人员安排
        deliverablesId: '', //交付物

      },
      rules: {
        deliverablesTypeId: [{
          required: true,
          message: '请选择交付物类型',
          trigger: 'change'
        }, ],
        deliverablesId: [{
          required: true,
          message: '请选择交付物',
          trigger: 'change'
        }, ],
        deliverablesName: [{
            required: true,
            message: '请输入交付物名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在200个字符以内',
            trigger: 'blur'
          }
        ],
        deliverablesQuantity: [{
            required: true,
            message: '请输入交付物数量',
            trigger: 'blur'
          },
          {
            type: 'number',
            message: '交付物数量必须为数字'
          }
        ],
        userId: [{
          required: true,
          message: '请选择人员',
          trigger: 'change'
        }, ],
        manHourInput: [{
            required: true,
            // message: '请输入人工时投入',
            trigger: 'blur',
            validator: validatorManHourInput,

          },

        ],

        companyId: [{
          required: true,
          message: '请选择单位名称',
          trigger: 'change'
        }, ],
        estimatedOutgoingAmount: [{
          required: false,
          // message: '请输入预计外发金额',
          trigger: 'blur',
          validator: validatorEstimatedOutgoingAmount,
        },
      ],
        estimatedRevenue: [{
          required: true,
          trigger: 'blur',
          validator: validatorEstimatedRevenue,
        },
     ],
      },
      tableData: [],
      allDeliverables: [],
      deliverablesTypeArr: [], //循环交付物类型
      deliverablesArr: [], //交付物
      firstTitle: '',
      id:null,
      getDetailInfo:{},
      type:'',
      allUserDate:[],
      suliper:[],
    }
  },
  watch: {

  },
  methods: {
    //禁用供应商选项
    disabledSuliper(index,itemId){
      const selectedIdArrOne = this.ruleForm.outgoingUnitList.slice(0, index);
      return selectedIdArrOne.findIndex((e) => +e.companyId == itemId) !== -1;
    },
    //禁用人员选项
     disabledTag(index,itemId){
      const selectedIdArrOne = this.ruleForm.staffingList.slice(0, index);
      return selectedIdArrOne.findIndex((e) => +e.userId === itemId) !== -1;
    },
    //提交表单
    submitForm(formName) {
    //跳转页面
      
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
          // if(this.type=='edit'){
            delete this.ruleForm.deliverablesTypeId
          // }
          console.log(this.ruleForm.staffingList,'ruleForm.staffingList')
          let sumExpectRate=0;
          for (let i of this.ruleForm.staffingList){
            sumExpectRate = Number(sumExpectRate) + parseFloat(i.expectRate)
          }
          console.log(sumExpectRate,'sumExpectRate')
          //如果预计人效合计大于预计收入 、不让她提交
          // if (sumExpectRate > this.ruleForm.estimatedRevenue){
          //   this.$message.error("预计人效合计数不能大于该交付物的预计收入");
          //   return
          // }
          for (let i of this.ruleForm.staffingList) {
            delete i.expectRate
          }
          let url=this.type=='edit'?BudgetAll.editProjectBudget:BudgetAll.addProjectBudget;
          this.ruleForm.estimatedRevenue=Number(this.ruleForm.estimatedRevenue)
          console.log(this.ruleForm,'===============')
          this.saveBtn=true;
        this.$http.post(url, this.ruleForm,{headers: { 'content-Type': 'application/json'}}).then((res)=>{
          this.saveBtn=false;
          if(res.data.retCode){
            Message.success({
              message:'新增成功'
            })
            this.$store.dispatch('changeisAddBuget', true)

            console.log(this.getDetailInfo.pId,'this.getDetailInfo.pId');
                this.$router.push({
                        path:`/projects/list/${this.$route.query.customerId}`,
                        query:{
                          id:this.getDetailInfo.pId,
                          customerId:this.$route.query.customerId,
                          currentTable:1
                        }
                      })
          }
        }).catch((err)=>{
          this.saveBtn=false;
          Message.error({
            message:'新增失败'
          })
          
        })
        } else {
          for (const prop in obj) {
            if (
              !this.ruleForm[prop] ||
              (Array.isArray(this.ruleForm[prop]) &&
                !this.ruleForm[prop].length)
            ) {
              Message.warning({
                message: obj[prop][0].message,
              });
              break;
            }
          }
          return false;
        }
      });
    },
    //添加单位、人员
    addUnit(type) {
      if (type == 'people') {
        let newPeople = {

          humanEfficiencyCalculation: '', //人效计算
          manHourInput: '', //人工时投入
          rate: '', //rate
          userId: '',
          peopleInvestment: '',

        };
        this.ruleForm.staffingList.push(newPeople);
      } else if (type == 'unit') {
        let newUni = {
          companyId: '',
          estimatedOutgoingAmount: '',
        };
        this.ruleForm.outgoingUnitList.push(newUni);
      }



    },
    filterChangeGoods(i){
      if(this.type=='edit') return
      this.ruleForm.deliverablesId = i.id;
    },
    async filterChange(item,i) {
      // this.firstTitle = item.id;
      if(this.type=='edit') return
      this.ruleForm.deliverablesTypeId = i.id;
      const deliverablesArr = await this.getDeliverablesArr(i.id);
      let deliverablesArrData = deliverablesArr.data.retData;
      this.deliverablesArr = deliverablesArrData;
      this.ruleForm.deliverablesId = null;

    },
    //获取三级标题
    getDeliverablesArr(id) {
      let params = {
        id
      }
      return this.$http.post(TimeSheet.getAllGoods, this.qs.stringify(params));
    },
    //更改交付物类型
    changeType(val) {
      this.deliverablesArr = this.allDeliverables[val]
    },
    // 交付物类型
    getdeliverables() {
      this.$http.post(TimeSheet.getDeliverables).then((res) => {
          let _data = res.data.retData;
          this.deliverablesTypeArr = _data;

        })
        .catch(err => {
          this.$message.error(`${err.toString()}`);

        })

    },
    //千分符
    formatMoney(item,money) {
      /* 先转数字固定小数，再转字符加千分位分隔符 */
      const m = parseFloat(money);
      item.expectRate = m;
      return isNaN(m) ? '' :thousandSplit(m.toFixed(2));
    },
    //获取所有人员的rate
    getUserRate(){
      this.$http.post(BudgetAll.getUserRate).then((res) => {
        console.log(res,'res=======')
        const _data=res.data.retData;
        this.allUserDate=_data;

      })
    },
    selectItem(item,val){
      console.log(val,'val------',item,'item=====')
      const chooseItem=this.allUserDate.filter(item=>item.id==val);
      console.log(chooseItem,'chooseItem')
      item.rate=chooseItem[0].rate;
      item.humanEfficiencyCalculation=chooseItem[0].humanEffect
      // item.
    },
    changeInvoiceNumber() {
      this.$forceUpdate()
    },
    //获取详情
      getDetail(){
        this.$http.post(BudgetAll.getProjectBudgetById, this.qs.stringify(this.getDetailInfo)).then((res)=>{
        const data=res.data.retData;
        const {deliverablesTypeId,deliverablesId,deliverablesName,deliverablesQuantity,id,outgoingUnitList,staffingList,estimatedRevenue}=data;
        this.ruleForm={deliverablesTypeId,deliverablesId,deliverablesName,deliverablesQuantity,id,outgoingUnitList,staffingList,estimatedRevenue};
        this.ruleForm.projectId=Number(this.getDetailInfo.pId);
        this.changeEstimatedRevenue(this.ruleForm.estimatedRevenue);
        this.ruleForm.outgoingUnitList=this.ruleForm.outgoingUnitList.map(item=>{
          return {
            companyId:item.companyId,
            estimatedOutgoingAmount:item.estimatedOutgoingAmount,
            id:item.id,
            projectBudgetId:item.projectBudgetId,
          }
        })
        this.ruleForm.staffingList=this.ruleForm.staffingList.map(item=>{
          return {
            humanEfficiencyCalculation:item.humanEfficiencyCalculation,
            manHourInput:item.manHourInput,
            id:item.id,
            projectBudgetId:item.projectBudgetId,
            rate:item.rate,
            userId:item.userId,
          }
        })
        //获取交付物
         Promise.all([
          (async () => {
                const deliverablesArr =await this.getDeliverablesArr(data.deliverablesTypeId);
                let deliverablesArrData = deliverablesArr.data.retData;
                this.deliverablesArr = deliverablesArrData;
              })(),
        ]);
      });
    },
    changeEstimatedRevenue(val){
      // this.ruleForm.estimatedRevenue=this.formatMoney(val);
      this.$forceUpdate()
    },
    //获取供应商
    getSuplier(){
      let params={
        page:1,
        perPage:1000,
        state:2
      }
      this.$http.post(Supply.list,Qs.stringify(params)).then((res) => {
        console.log(res,'params======')
        this.suliper=res.data.retData.data;
        console.log(this.suliper,'this.suliper')
      })
    },
    //删除报销任务
    reduceItem(type) {
      if(type=='people'){
        this.ruleForm.staffingList.pop();
      }else if(type=='unit'){
        this.ruleForm.outgoingUnitList.pop();

      }
      
    },
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
    window.pageYOffset = 0;
    this.getdeliverables();
    if(this.$route.query.dId){
      this.getDetailInfo={
        dId:this.$route.query.dId,
        pId:this.$route.query.pId
      }
      this.type='edit'
      this.getDetail();
      
      
    }
    this.getDetailInfo.pId=this.$route.query.pId;
    console.log(this.getDetailInfo.pId,'this.getDetailInfo.pId',this.ruleForm.projectId);
    this.getUserRate();
    this.getSuplier();
  },

}
